<template>
    <v-container fluid>
        <v-card elevation="4" class="pa-4">
            <v-card-title class="d-flex align-center">
                <v-icon left color="primary">mdi-history</v-icon>
                Auditoría del sistema
                <v-spacer></v-spacer>
                <v-btn small class="perfil-btn mr-2" style="background-color: #5e672c; text-transform: none;" dark @click="listarLog">
                    <v-icon left small>mdi-refresh</v-icon>
                    Actualizar
                </v-btn>
            </v-card-title>
            <v-row class="mb-3">
                <v-col cols="12" md="2">
                    <v-text-field v-model="search" label="Buscar" outlined dense clearable prepend-inner-icon="mdi-magnify" />
                </v-col>

                <v-col cols="12" md="2">
                    <v-select v-model="filtroModulo" :items="modulos" label="Módulo" outlined dense clearable />
                </v-col>

                <v-col cols="12" md="2">
                    <v-select v-model="filtroAccion" :items="acciones" label="Acción" outlined dense clearable />
                </v-col>

                <v-col cols="12" md="2">
                    <v-text-field v-model="filtroUsuario" label="Usuario" outlined dense clearable />
                </v-col>

                <v-col cols="12" md="2">
                    <v-text-field v-model="fechaInicio" label="Fecha inicio" type="date" outlined dense clearable />
                </v-col>

                <v-col cols="12" md="2">
                    <v-text-field v-model="fechaFin" label="Fecha fin" type="date" outlined dense clearable />
                </v-col>

                <v-col cols="12" class="d-flex justify-end">
                    <v-btn small class="perfil-btn mr-2" style="background-color: #e4b510; text-transform: none;" dark :disabled="logsFiltrados.length === 0" @click="exportarExcel">
                        <v-icon left small>mdi-file-excel</v-icon>
                        Exportar Excel
                    </v-btn>
                </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="logsFiltrados" :loading="loading" :search="search" item-key="oid" :items-per-page="25" class="elevation-1">
                <template v-slot:item.fecha="{ item }">
                    {{ formatFecha(item.fecha) }}
                </template>

                <template v-slot:item.accion="{ item }">
                    <v-chip small dark :color="colorAccion(item.accion)">
                        {{ item.accion }}
                    </v-chip>
                </template>

                <template v-slot:item.user_agent="{ item }">
                    <span class="text-truncate d-inline-block" style="max-width: 220px;">
                        {{ item.user_agent }}
                    </span>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon small color="primary" v-on="on" @click="verDetalle(item)">
                                <v-icon small>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <span>Ver detalle</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialogDetalle" max-width="90%" scrollable>
            <v-card>
                <v-card-title>
                    <v-icon left color="primary">mdi-file-document-outline</v-icon>
                    Detalle de auditoría
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogDetalle = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />

                <v-card-text v-if="logSeleccionado" class="pt-4">
                    <v-row>
                        <v-col cols="12" md="4">
                            <strong>Usuario:</strong> {{ logSeleccionado.usuario }}
                        </v-col>
                        <v-col cols="12" md="4">
                            <strong>Módulo:</strong> {{ logSeleccionado.modulo }}
                        </v-col>
                        <v-col cols="12" md="4">
                            <strong>Acción:</strong> {{ logSeleccionado.accion }}
                        </v-col>
                        <v-col cols="12">
                            <strong>Descripción:</strong> {{ logSeleccionado.descripcion }}
                        </v-col>
                        <v-col cols="12" md="6">
                            <strong>IP:</strong> {{ logSeleccionado.ip }}
                        </v-col>
                        <v-col cols="12" md="6">
                            <strong>Fecha:</strong> {{ formatFecha(logSeleccionado.fecha) }}
                        </v-col>
                    </v-row>

                    <v-row class="mt-4">
                        <!-- <v-col cols="12" md="6">
                            <v-card outlined>
                                <v-card-title class="subtitle-1">
                                    Datos anteriores
                                </v-card-title>
                                <v-card-text>
                                    <pre class="json-box">{{ prettyJson(logSeleccionado.datos_anteriores) }}</pre>
                                </v-card-text>
                            </v-card>
                        </v-col> -->

                        <v-col cols="12" md="12">
                            <v-card outlined>
                                <v-card-title class="subtitle-1">
                                    LOG de cambios
                                </v-card-title>
                                <v-card-text>
                                    <pre class="json-box">{{ prettyJson(logSeleccionado.datos_nuevos) }}</pre>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';

export default {
    name: 'AuditoriaLog',

    data() {
        return {
            loading: false,
            logs: [],
            search: '',
            filtroModulo: null,
            filtroAccion: null,
            filtroUsuario: '',
            fechaInicio: '',
            fechaFin: '',
            dialogDetalle: false,
            logSeleccionado: null,

            headers: [
                { text: 'Fecha', value: 'fecha' },
                { text: 'Usuario', value: 'usuario' },
                { text: 'Módulo', value: 'modulo' },
                { text: 'Entidad', value: 'entidad' },
                { text: 'Acción', value: 'accion' },
                { text: 'Descripción', value: 'descripcion' },
                { text: 'IP', value: 'ip' },
                { text: 'User-Agent', value: 'user_agent' },
                { text: 'Detalle', value: 'actions', sortable: false }
            ]
        };
    },

    computed: {
        modulos() {
            return [...new Set(this.logs.map(x => x.modulo).filter(Boolean))];
        },

        acciones() {
            return [...new Set(this.logs.map(x => x.accion).filter(Boolean))];
        },
        logsFiltrados() {
            return this.logs.filter(x => {
                const cumpleModulo = !this.filtroModulo || x.modulo === this.filtroModulo;
                const cumpleAccion = !this.filtroAccion || x.accion === this.filtroAccion;
                const cumpleUsuario = !this.filtroUsuario || (x.usuario || '').toLowerCase().includes(this.filtroUsuario.toLowerCase());

                const fechaLog = this.fechaKey(x.fecha);

                const cumpleFechaInicio = !this.fechaInicio || fechaLog >= this.fechaInicio;
                const cumpleFechaFin = !this.fechaFin || fechaLog <= this.fechaFin;

                return cumpleModulo && cumpleAccion && cumpleUsuario && cumpleFechaInicio && cumpleFechaFin;
            });
        },
    },

    mounted() {
        this.listarLog();
    },

    methods: {
        async listarLog() {
            this.loading = true;

            try {
                const response = await axios.get('api/PersonaInfoGenerals/ListarLog');
                this.logs = response.data || [];
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        verDetalle(item) {
            this.logSeleccionado = item;
            this.dialogDetalle = true;
        },

        formatFecha(fecha) {
            if (!fecha) return '';
            return new Date(fecha).toLocaleString();
        },

        prettyJson(value) {
            if (!value) return 'Sin datos';

            try {
                return JSON.stringify(JSON.parse(value), null, 2);
            } catch {
                return value;
            }
        },

        colorAccion(accion) {
            switch ((accion || '').toUpperCase()) {
                case 'CREAR':
                    return 'green';
                case 'ACTUALIZAR':
                case 'EDITAR':
                    return 'blue';
                case 'ELIMINAR':
                    return 'red';
                case 'LOGIN':
                    return 'purple';
                case 'IMPORTAR':
                    return 'orange';
                default:
                    return 'grey';
            }
        },
        fechaKey(fecha) {
            if (!fecha) return '';

            const f = new Date(fecha);
            if (isNaN(f)) return '';

            const year = f.getFullYear();
            const month = String(f.getMonth() + 1).padStart(2, '0');
            const day = String(f.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        exportarExcel() {
            const datos = this.logsFiltrados.map(x => ({
                Fecha: this.formatFecha(x.fecha),
                Usuario: x.usuario || '',
                Modulo: x.modulo || '',
                Entidad: x.entidad || '',
                OidEntidad: x.oid_entidad || '',
                Accion: x.accion || '',
                Descripcion: x.descripcion || '',
                IP: x.ip || '',
                UserAgent: x.user_agent || '',
                DatosAnteriores: this.prettyJson(x.datos_anteriores),
                DatosNuevos: this.prettyJson(x.datos_nuevos)
            }));

            const ws = XLSX.utils.json_to_sheet(datos);

            ws['!cols'] = [
                { wch: 24 },
                { wch: 30 },
                { wch: 22 },
                { wch: 28 },
                { wch: 12 },
                { wch: 18 },
                { wch: 60 },
                { wch: 18 },
                { wch: 80 },
                { wch: 80 },
                { wch: 80 }
            ];

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Auditoria');

            XLSX.writeFile(wb, `Auditoria_${new Date().toISOString().slice(0, 10)}.xlsx`);
        }
    }
};
</script>

<style scoped>
.json-box {
    background: #f5f5f5;
    padding: 12px;
    border-radius: 6px;
    max-height: 400px;
    overflow: auto;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
}

.text-truncate {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>